export default __webpack_public_path__ + "static/media/archive.c5d0eb1b.svg";